/**
 *  Sort media by priority, if priority is 0 put it in the back
 */
const sortMediaPriority = (media: any[]) => {
  const sortedMedia = [...media];
  return sortedMedia.sort((a, b) => {
    if (a.priority < b.priority || b.priority === 0) {
      return -1;
    }
    if (a.priority > b.priority) {
      return 1;
    }
    return 0;
  });
};

export default sortMediaPriority;
